import { Button as AntdButton } from "antd";
import type { ButtonProps } from "antd";
import { forwardRef } from "react";

export type ExtendedButtonProps = Omit<ButtonProps, "variant"> & {
  variant?: ButtonProps["variant"] | "light";
};

export const Button = forwardRef<HTMLButtonElement, ExtendedButtonProps>(
  ({ variant, styles, ...rest }, ref) => {
    const isLight = variant === "light";
    const finalVariant = isLight ? "text" : variant;
    // antd 6 types `styles` as a record-or-function union; only a record can
    // be merged into our `root` override, a function form is passed through.
    const stylesRecord =
      typeof styles === "object" && styles !== null ? styles : undefined;
    const finalStyles =
      isLight && (!rest?.type || rest?.type === "default")
        ? {
            ...stylesRecord,
            root: {
              "--ant-btn-color": "#000000",
              "--ant-btn-background": "#ffffff",
              "--ant-btn-border-color": "#e3e3e3",
              "--ant-btn-bg-color-hover": "#f5f5f5",
              "--ant-btn-active-background": "#e6e6e6",
              "--ant-btn-border-color-hover": "#dddddd",
              "--ant-btn-text-color-hover": "#000000",
              ...stylesRecord?.root,
            },
          }
        : styles;

    return (
      <AntdButton
        {...rest}
        ref={ref}
        variant={finalVariant}
        styles={finalStyles}
      />
    );
  },
);
